<!-- 文创产品 -->
<template>
  <div id="app">
    <div class="web_container">
      <div class="body_container">
        <!-- 头部 -->
        <div class="header_container">
          <div class="header_content_container">
            <img class="header_content_wechat" src="../assets/cultural_products/ico_qrcode.png" />
            <div class="header_content_text_container">
              <span class="header_content_title">文创产品</span>
              <span class="header_content_dec">手机扫码去商城，<br />Pick你喜欢的文创产品……</span>
            </div>
            <img class="header_content_cat" src="../assets/big_picture/ico_cat.png" />
          </div>
        </div>
        <!-- 内容 -->
        <div class="content_container">
          <div class="commodity_container">
            <div class="commodity_content_container" v-for="(item,index) in items1" @click="onItemClick(item,index)">
              <img class="commodity_img" :src="item.cover" />
              <span class="commodity_title">{{item.name}}</span>
              <span class="commodity_price">¥{{item.price}}</span>
            </div>
            <Page class="commodity_index" :total="total" :limit="6" :defultPage="defultPage" :defultJump="1"
              @change="pageChange">
            </Page>
          </div>
          <!-- 分割线 -->
          <div class="line"></div>
        </div>
      </div>
    </div>

    <div class="phone_container">
      <div class="phone_body_container">
        <!-- 头部 -->
        <div class="phone_header_container">
          <img class="phone_header_ico" src="../assets/cultural_products/phone_ico_logo.png" />
          <span class="phone_header_content_title">文创产品</span>
          <span class="phone_header_content_dec">手机扫码去商城，<br />Pick你喜欢的文创产品……</span>
        </div>
        <!-- 内容 -->
        <div class="phone_content_container">
          <img class="phone_content_wechat" src="../assets/cultural_products/phone_ico_qrcode.png" />
          <div class="phone_commodity_container">
            <div class="phone_commodity_content_container" v-for="(item,index) in items"
              @click="onItemClick(item,index)">
              <img class="phone_commodity_img" :src="item.cover" />
              <span class="phone_commodity_title">{{item.name}}</span>
              <span class="phone_commodity_price">¥{{item.price}}</span>
            </div>
          </div>
          <!-- 分割线 -->
          <div class="phone_line"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Page from './custom/page.vue';
  export default {
    name: 'culturalProducts',
    created: function() {
      let that = this;
      this.$http.get("https://www.everglamming.com/hrym-admin/cultural/listAll?isShowAll=1&pageNum=1&pageSize=10000").then(function(
        response) {
        that.items = response.data.data.list;
        that.total = that.items.length;
        that.defultPage = Math.ceil(that.total/6) ;
        if (that.total >= 6) {
          that.items1 = that.items.slice(0, 6);
        } else {
          that.items1 = that.items.slice(0, that.total);
        }
      }, function(error) {

      });
    },

    data() {
      return {
        items: [],
        total: 0,
        defultPage:0,
        items1: []
      };
    },
    components: {
      Page,
    },
    methods: {
      pageChange(index) {
        this.total = this.items.length;
        var count = this.total - index * 6;
        if (count > 0) {
          this.items1 = this.items.slice((index - 1) * 6, (index - 1) * 6+6);
        } else {
          this.items1 = this.items.slice((index - 1) * 6, this.total);
        }
      },
      onItemClick(item, index) {
        var url = item.url;
        window.open(url, '_blank');
        //window.location.href = 'https://shop95042795.m.youzan.com/wscgoods/detail/2oedm7x73ym9v?scan=1&activity=none&from=kdt&qr=directgoods_986272180&shopAutoEnter=1'
      }
    }
  }
</script>

<style scoped>
  @font-face {
    font-family: ht;
    src: url("../assets/font/HT.otf");
  }

  .web_container {
    width: 100%;
  }

  .body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .header_container {
    background-size: 100%;
    width: 100%;
    height: 25vw;
    background-image: url('../assets/home/bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: center;
  }

  .header_content_container {
    width: 37.5vw;
    height: 12.5vw;
    background: rgba(237, 237, 238, 0.7);
    border-radius: 1.25vw;
    border: 0.15625vw solid #FFFFFF;
    margin-left: 1.822916vw;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .header_content_wechat {
    height: 10.416666vw;
    width: 10.416666vw;
    margin-left: 1.041666vw;
  }

  .header_content_text_container {
    display: flex;
    flex-direction: column;
  }

  .header_content_title {
    font-family: ht;
    font-size: 2.5vw;
    color: #000000;
    margin-left: 1.666666vw;
  }

  .header_content_dec {
    font-family: ht;
    font-size: 1.25vw;
    color: #4E4D4D;
    margin-top: 1.25vw;
    line-height: 1.666666vw;
    margin-left: 1.666666vw;
  }

  .header_content_cat {
    height: 6.25vw;
    width: 6.614583vw;
    margin-top: 6.25vw;
    margin-left: 3.61vw;
  }

  .content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .commodity_container {
    width: 62.5vw;
    display: flex;
    flex-direction: row;
    margin-top: 4.375vw;
    flex-wrap: wrap;
  }

  .commodity_content_container {
    display: flex;
    flex-direction: column;
    margin-top: 3.75vw;
    margin-left: 1.25vw;
  }

  .commodity_img {
    width: 18.75vw;
    height: 18.75vw;
    border: 0.15625vw solid #FFFFFF;
  }

  .commodity_title {
    font-family: 'PingFang SC';
    font-size: 1.25vw;
    color: #000000;
    margin-top: 1.25vw;
  }

  .commodity_price {
    font-family: 'PingFang SC';
    font-size: 2.083333vw;
    color: #F5A623;
    margin-top: 0.416666vw;
  }

  .commodity_index {
    margin-top: 3.75vw;
  }

  .line {
    height: 0.052083vw;
    width: 52.083333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 4.166666vw;
    margin-bottom: 4.166666vw;
  }

  .phone_container {
    width: 100%;
  }

  .phone_body_container {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_container {
    background-size: 100%;
    width: 100%;
    height: 87.466666vw;
    background-image: url('../assets/home/phone_bg_header.png');
    /* background-repeat: no-repeat; */
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_header_ico {
    height: 32vw;
    width: 21.866666vw;
    margin-top: 21.333333vw;
  }

  .phone_header_content_title {
    font-family: ht;
    font-size: 6.4vw;
    color: #000000;
    margin-top: 6.4vw;
  }

  .phone_header_content_dec {
    font-family: ht;
    font-size: 4.266666vw;
    color: #4E4D4D;
    margin-top: 2.133333vw;
    text-align: center;
  }

  .phone_content_container {
    background-size: 100%;
    width: 100%;
    background-image: url('../assets/home/bg_content.png');
    background-repeat: repeat;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .phone_content_wechat {
    height: 25.466666vw;
    width: 25.466666vw;
  }

  .phone_commodity_container {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-top: 1.333333vw;
    flex-wrap: wrap;
  }

  .phone_commodity_content_container {
    display: flex;
    flex-direction: column;
    margin-top: 12.8vw;
    margin-left: 6.4vw;
    width: 40.533333vw;
  }

  .phone_commodity_img {
    width: 40.533333vw;
    height: 40.533333vw;
    border: 0.8vw solid #FFFFFF;
  }

  .phone_commodity_title {
    font-family: 'PingFang SC';
    font-size:4.8vw;
    color: #000000;
    margin-top: 2.133333vw;
    flex-wrap:wrap;
  }

  .phone_commodity_price {
    font-family: 'PingFang SC';
    font-size: 6.4vw;
    color: #F5A623;
    margin-top:2.133333vw;
  }

  .phone_bottom_img {
    width: 78.666666vw;
    height: 51.2vw;
    margin-top: 8.533333vw;
  }

  .phone_line {
    height: 0.266666vw;
    width: 89.333333vw;
    background-color: rgba(151, 151, 151, 0.3);
    margin-top: 17.066666vw;
    margin-bottom: 8.266666vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/CulturalProducts.vue